module.exports = __webpack_public_path__ + "static/media/Joshua_Schumacher_headshot.c762d7bd.jpg";